import React from 'react';
import { DataProviderInstance } from '../../../../api/DataProvider';
import { SendWhatsAppMessage } from '../../../../api/WhatsappAPI';
import MessagesTemplate from '../../../../consts/MessagesTemplate';
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined';
import usePlanLock from '../../../../hooks/usePlanLock';
import { SUBSCRIPTION_PERMISSIONS } from '../../../../consts/SubscriptionFeatures';
import PatientItem from '../shared/PatientItem';
import { ContactActions } from '../shared/IconAction';
import useSentFlag from '../../hooks/useSentFlag';
import RelationshipSection from './RelationshipSection';

function GoogleReviewItem({ item, onBlockedAction }) {
  const { CompanyConfig } = DataProviderInstance();
  const templates = MessagesTemplate.getTemplates(CompanyConfig);
  const [sent, markSent] = useSentFlag(`googleReviewMsgSent-v2-${item.patient_id}-${item.score}`);
  const hasPhone = item.patient_phone && item.patient_phone.length >= 8;

  function handleWhatsApp() {
    if (onBlockedAction) {
      onBlockedAction();
      return;
    }
    let message = templates.GoogleReviewRequest || '';
    if (!message) return;

    const firstName = item.patient_name ? item.patient_name.split(' ')[0] : '';
    message = message.replaceAll('{name}', firstName);
    message = message.replaceAll('{company_name}', CompanyConfig?.Name || '');

    if (item.google_review_url) {
      message += `\n\nClique no link abaixo para avaliar:\n${item.google_review_url}`;
    }

    SendWhatsAppMessage(item.patient_phone, MessagesTemplate.ConvertToWhatsAppText(message), item.patient_country);
    markSent();
  }

  return (
    <PatientItem
      name={item.patient_name}
      patientId={item.patient_id}
      tone="amber"
      sent={sent}
      meta={`Deu nota ${item.score} na pesquisa`}
      actions={hasPhone && <ContactActions whatsappTitle="Pedir avaliação no Google" onWhatsApp={handleWhatsApp} phone={item.patient_phone} />}
    />
  );
}

function GoogleReviewSection({ list }) {
  // Sem relacionamento pela Gabriela e sem número próprio (Essencial), a seção
  // continua visível e o envio abre o modal de planos.
  const lock = usePlanLock(
    [SUBSCRIPTION_PERMISSIONS.PLATFORM_ENGAGEMENT, SUBSCRIPTION_PERMISSIONS.ZAPI_INTEGRATION],
    'O convite para avaliar no Google'
  );

  return (
    <RelationshipSection
      icon={<RateReviewOutlinedIcon style={{ fontSize: 15 }} />}
      tone="amber"
      title="Avaliações no Google"
      hint="Pacientes que deram nota alta"
      count={list.length}
      lock={lock}
    >
      {list.map((item, index) => (
        <GoogleReviewItem key={item.id || index} item={item} onBlockedAction={lock.locked ? lock.openUpgrade : null} />
      ))}
    </RelationshipSection>
  );
}

export default GoogleReviewSection;
